import {
	Copy01,
	DotsHorizontal,
	DotsVertical,
	Trash01,
} from "@untitledui/icons";
import type { MouseEvent } from "react";
import { Button as AriaButton } from "react-aria-components";
import { Dropdown } from "@/components/base/dropdown/dropdown";
import {
	SECTION_DESCRIPTION_MAX_LENGTH,
	SECTION_TITLE_MAX_LENGTH,
} from "../types/template";

type FormSectionItemProps = {
	title: string;
	description?: string;
	isActive?: boolean;
	onClick?: () => void;
	onTitleChange?: (title: string) => void;
	onDescriptionChange?: (description: string) => void;
	onDuplicate?: () => void;
	onDelete?: () => void;
	onDragHandleMouseDown?: (event: MouseEvent) => void;
	isDragging?: boolean;
};

export function FormSectionItem({
	title,
	description,
	onTitleChange,
	onDescriptionChange,
	onDuplicate,
	onDelete,
	onDragHandleMouseDown,
	isDragging = false,
}: FormSectionItemProps) {
	return (
		<div
			className={`flex items-start gap-4 ${isDragging ? "opacity-40" : ""}`}
			data-slot="form-section-item"
		>
			{!!onDragHandleMouseDown && (
				<button
					aria-label="Arrastar seção"
					className="mt-2 cursor-grab touch-none rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 active:cursor-grabbing"
					onMouseDown={onDragHandleMouseDown}
					tabIndex={0}
					type="button"
				>
					<DotsVertical aria-hidden className="size-5" />
				</button>
			)}
			<div className="grow">
				<div className="flex items-start justify-between gap-4 border-gray-300 border-l-4 pl-4">
					<div className="grow">
						<input
							className="w-full border-none font-bold text-[20px] text-gray-900"
							maxLength={SECTION_TITLE_MAX_LENGTH}
							onChange={(e) => onTitleChange?.(e.target.value)}
							placeholder="Nome da Seção"
							type="text"
							value={title}
						/>
						<input
							className="w-full border-none text-[14px] text-gray-400 placeholder:text-gray-400"
							maxLength={SECTION_DESCRIPTION_MAX_LENGTH}
							onChange={(e) => onDescriptionChange?.(e.target.value)}
							placeholder="Descrição da Seção"
							type="text"
							value={description ?? ""}
						/>
					</div>

					<Dropdown.Root>
						<AriaButton className="rounded-lg p-2 transition-colors hover:bg-gray-100">
							<DotsHorizontal className="size-5" color="#A4A7AE" />
						</AriaButton>

						<Dropdown.Popover className="w-40">
							<Dropdown.Menu>
								<Dropdown.Item
									icon={Copy01}
									label="Duplicar"
									onAction={onDuplicate}
								/>
								<Dropdown.Item
									className="text-red-600"
									icon={Trash01}
									label="Excluir"
									onAction={onDelete}
								/>
							</Dropdown.Menu>
						</Dropdown.Popover>
					</Dropdown.Root>
				</div>
			</div>
		</div>
	);
}
